import { Navigate, useLocation } from "react-router-dom";
import { ROUTES } from "../../route_paths";
import NoCoverage from "./NoCoverage";

/** What the page needs, passed in the navigation state by the page that stopped the claim. */
export interface OutsideHealthState {
  claimId: string;
  claimText: string;
}

/** The page for a claim outside health: a person who arrives without a claim starts over. */
export default function OutsideHealthPage() {
  const state = useLocation().state as OutsideHealthState | null;
  if (!state) return <Navigate to={ROUTES.landing.path()} replace />;
  return <NoCoverage reason="outside_health" claimText={state.claimText} />;
}
